import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;

export enum BusEvent {
    Authed = 'authed',
    PushRoute = 'pushRoute'
}